export const DefaultTeammateFilter = "ALL_ACTIVE";

export const DefaultJourneyStatusFilter = "ALL";

export const DefaultContentTemplatesStatusFilter = "ACTIVE";

export const DefaultEmailTemplatesStatusFilter = "ACTIVE";

export const DefaultInterviewTemplatesStatusFilter = "ACTIVE";

export const DefaultGuideTemplatesStatusFilter = "ACTIVE";
